import { EscalationReason, isEscalationReason } from "../Explore.model";

const escalationReasonToLabel: Record<EscalationReason, string> = {
  USER_REQUESTED: "User Requested",
  OUT_OF_POLICY: "Out of Policy",
  KNOWLEDGE_GAP: "Knowledge Gap",
  LOW_CONFIDENCE: "Low Confidence",
  STRICT_MODE: "Strict Mode",
  BY_INSTRUCTIONS: "By Instructions",
  ERROR: "Error",
  MAX_MESSAGES: "Max Messages",
  PICKUP_TIME_LIMIT: "Pickup Time Limit",
  UNCLASSIFIED: "Unclassified",
};

export function getEscalationReasonText(value: string): string {
  return isEscalationReason(value) ? escalationReasonToLabel[value] : "";
}

export function EscalationReasonFormatter({ value }: { value?: string }) {
  if (value == null || !isEscalationReason(value)) {
    return <></>;
  }

  return <>{getEscalationReasonText(value)}</>;
}
